import { SvgIcon, SvgIconProps } from '@mui/material';

export const Close = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" sx={sx} {...props}>
    <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);
